export const TabsTestIdFactory = {
    getTabListBase: () => 'tab-list',
    getTabListTestId: (testId) => [TabsTestIdFactory.getTabListBase(), testId].filter(Boolean).join('-'),
    getTabBase: () => 'tab',
    getTabTestId: (tabId) => [TabsTestIdFactory.getTabBase(), tabId].join('-'),
    getTabTextBase: () => [TabsTestIdFactory.getTabBase(), 'text'].join('-'),
    getTabTextTestId: (tabId) => [TabsTestIdFactory.getTabTextBase(), tabId].join('-'),
    getTabPanelBase: () => 'panel',
    getTabPanelTestId: (tabId) => [TabsTestIdFactory.getTabPanelBase(), tabId].join('-'),
};
